// `MediaError` constants, spelled out rather than read off the global: jsdom's
// `MediaError` shim is incomplete, and the numbers stay readable at the call sites.
export const MEDIA_ERR_ABORTED = 1;
export const MEDIA_ERR_NETWORK = 2;
export const MEDIA_ERR_DECODE = 3;
export const MEDIA_ERR_SRC_NOT_SUPPORTED = 4;

/**
 * Whether offering the student a retry can plausibly change the outcome. NETWORK/ABORTED
 * are transient. SRC_NOT_SUPPORTED (the element refused the source) is on native usually
 * the CDN rejecting the CORS-mode media fetch that `crossOrigin="anonymous"` forces for
 * subtitles, so it is recoverable exactly while that attribute is still there to drop —
 * without that lever a reload repeats verbatim. DECODE never is: the bytes arrived and
 * are undecodable.
 */
export function isVideoErrorRecoverable(
  code: number | null,
  corsFallbackAvailable: boolean
): boolean {
  switch (code) {
    case MEDIA_ERR_NETWORK:
    case MEDIA_ERR_ABORTED:
      return true;
    case MEDIA_ERR_SRC_NOT_SUPPORTED:
      return corsFallbackAvailable;
    case MEDIA_ERR_DECODE:
      return false;
    default:
      // Unknown/absent code: a reload is cheap and might work.
      return true;
  }
}
